import React from 'react';
import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';
import PrivateRoute from 'components/route/private';
import PrivateAdminRoute from 'components/route/private_admin';
import Dashboard from 'pages/dashboard';
import UserLogin from 'pages/user/login';
import UserRegister from 'pages/user/register';
import UserForgotPassword from 'pages/user/forgot_password';
import UserConfirmation from 'pages/user/confirmation';
import UserResetPassword from 'pages/user/reset_password';
import Profile from 'pages/user/profile';
import DeleteConfirmation from 'pages/user/delete_confirmation';
import Inspections from 'pages/inspections';
import InspectionSubjects from 'pages/inspection_subjects';
import Places from 'pages/places';
import PlacesShow from 'pages/places/show';
import InspectionSubject from 'pages/inspection_subjects/show';
import Inspection from 'pages/inspections/show';
import InspectionResult from 'pages/inspection_results/show';
import Templates from 'pages/templates';
import Template from 'pages/templates/show';
import PublicAuthRoute from 'components/route/public_auth';
import PrivateNoSpaceRoute from 'components/route/private_no_space';
import SpaceRedirect from 'components/route/space_redirect';
import Spaces from 'pages/spaces';
import SpaceShow from 'pages/spaces/show';
import PaymentRedirect from 'pages/spaces/billing/payment_redirect';
import Notifications from 'pages/notifications';
import NotFound from 'pages/not_found';
import SomethingWrong from 'pages/something_wrong';
import RootLayout from './root_layout';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<RootLayout />}>
      <Route element={<PublicAuthRoute />}>
        <Route path="/users/login" element={<UserLogin />} />
        <Route path="/users/register" element={<UserRegister />} />
        <Route path="/users/forgot_password" element={<UserForgotPassword />} />
        <Route path="/users/reset_password/:token" element={<UserResetPassword />} />
        <Route path="/users/confirm/:token" element={<UserConfirmation />} />
        <Route path="*" element={<UserLogin />} />
      </Route>
      <Route element={<PrivateNoSpaceRoute />}>
        <Route path="/spaces/:spaceId" element={<SpaceRedirect to="/dashboard" />} />
        <Route path="/spaces/:spaceId/inspections" element={<SpaceRedirect to="/inspections" />} />
        <Route path="/spaces/:spaceId/inspections/:inspectionId" element={<SpaceRedirect to="/inspections/:inspectionId" />} />
        <Route path="/not-found" element={<NotFound />} />
        <Route path="/something-wrong" element={<SomethingWrong />} />
      </Route>
      <Route element={<PrivateRoute />}>
        <Route path="/spaces" element={<Spaces />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/inspections" element={<Inspections />} />
        <Route path="/inspections/:inspectionId" element={<Inspection />} />
        <Route
          path="/inspection_results/:inspectionResultId"
          element={<InspectionResult />}
        />
        <Route path="/inspection_subjects" element={<InspectionSubjects />} />
        <Route path="/inspection_subjects/:inspectionSubjectId" element={<InspectionSubject />} />

        <Route path="/places" element={<Places />} />
        <Route path="/places/:id" element={<PlacesShow />} />

        <Route path="/users/delete/:token" element={<DeleteConfirmation />} />

        <Route path="/templates" element={<Templates />} />
        <Route path="/templates/:id" element={<Template />} />

        <Route element={<PrivateAdminRoute />}>
          <Route path="/billing/success" element={<PaymentRedirect outcome="success" />} />
          <Route path="/billing/failure" element={<PaymentRedirect outcome="failure" />} />
          <Route path="/space" element={<SpaceShow />} />
        </Route>

        <Route path="/notifications" element={<Notifications />} />

        <Route path="*" element={<Dashboard />} />
      </Route>
    </Route>
  )
);

export default router;
